import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as userDataActions from '../../../actions/userDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appDataActions from '../../../actions/appDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as environmentHelper from '../../../helpers/environmentHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as appConstants from '../../../constants/appConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import {CircularProgressbarWithChildren, buildStyles} from 'react-circular-progressbar';

class SimpleAudioController extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {

            lang: this.props.lang,
            audio: props.audio,
            showLabels: appHelper.isDefined(props.showLabels) ? props.showLabels : true,
            showAnimation: appHelper.isDefined(props.showLabels) ? props.showAnimation : true,
            status: objectConstants.CLASS_NOT_STARTED,
            play_label: appHelper.getLocaleString("play_label"),
            replay_label: appHelper.getLocaleString("replay_label"),
            pause_label: appHelper.getLocaleString("pause_label"),
            continue_label: appHelper.getLocaleString("continue_label"),
            audioIsPlaying: false,
            id: this.props.audioRef,
            currentAudioId: props.currentAudioId,
            percentagePlayed: 0,
            browser: environmentHelper.getEnvironment().browser.name,
        };
        this.getAssetPath = this.getAssetPath.bind(this);
        this.playAudio = this.playAudio.bind(this);
        this.pauseAudio = this.pauseAudio.bind(this);
        this.playAudioOnKeyClick = this.playAudioOnKeyClick.bind(this);
        this.pauseAudioOnKeyClick = this.pauseAudioOnKeyClick.bind(this);

        this.audioRef = React.createRef();
    }


    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.lang !== nextProps.lang && appHelper.isDefined(nextProps.lang)) {
            return ({
                lang: nextProps.lang,
                play_label: appHelper.getLocaleString("play_label"),
                replay_label: appHelper.getLocaleString("replay_label"),
                pause_label: appHelper.getLocaleString("pause_label"),
                continue_label: appHelper.getLocaleString("continue_label"),
            });
        }

        if (prevState.currentAudioId !== nextProps.currentAudioId && appHelper.isDefined(nextProps.currentAudioId)) {
            return ({
                currentAudioId: nextProps.currentAudioId,
                pauseIfPlaying: prevState.audioIsPlaying && nextProps.currentAudioId !== prevState.id
            });
        }
    }

    componentDidMount() {
        if (this.props.autoPlay) {
            this.playAudio();
        }
    }

    componentDidUpdate() {
        if (this.state.pauseIfPlaying) {
            this.pauseAudio();
        }
    }

    old_componentWillReceiveProps(nextProps) {
        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                play_label: appHelper.getLocaleString("play_label"),
                replay_label: appHelper.getLocaleString("replay_label"),
                pause_label: appHelper.getLocaleString("pause_label"),
                continue_label: appHelper.getLocaleString("continue_label"),
            });
        }
        if (this.state.currentAudioId !== nextProps.currentAudioId) {
            this.setState({
                currentAudioId: nextProps.currentAudioId,
                pauseIfPlaying: this.state.audioIsPlaying && nextProps.currentAudioId !== this.state.id
            });
        }
    }

    getAssetPath(asset) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(asset) && asset.length > 0) {
                return require(`../../../../moveToDist/${asset}`);
            }
        } else {
            return asset;
        }
    }

    playAudio(event) {

        if (appHelper.isDefined(event)) {
            event.preventDefault();
            event.stopPropagation();
        }

        let audioRef = this.audioRef.current;
        if (appHelper.isDefined(audioRef) && audioRef !== null) {
            //audioRef.currentTime = 0;
            this.setState({
                audioIsPlaying: true
            });
            audioRef.play();

            audioRef.onplay = function () {
                this.props.actions.setCurrentAudio(this.state.id);
                this.setState({
                    audioIsPlaying: true
                });
            }.bind(this);

            audioRef.ontimeupdate = function () {
                let currentTime = audioRef.currentTime;
                let duration = audioRef.duration;
                this.setState({percentagePlayed: (currentTime / duration) * 100});

                //$('.hp_range').stop(true,true).animate({'width':(currentTime +.25)/duration*100+'%'},250,'linear');
            }.bind(this);

            audioRef.onended = function () {

                this.setState({
                    status: objectConstants.STATUS_COMPLETE,
                    audioIsPlaying: false,
                });
            }.bind(this);
        }
    }

    pauseAudio(event) {
        if (appHelper.isDefined(event)) {
            event.preventDefault();
            event.stopPropagation();
        }
        let audioRef = this.audioRef.current;
        if (appHelper.isDefined(audioRef)  && audioRef !== null) {
            audioRef.pause();
            this.setState({audioIsPlaying: false, pauseIfPlaying: false});
        }

    }

    playAudioOnKeyClick(event) {
        if (appHelper.isDefined(event)) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.playAudio();
        }
    }

    pauseAudioOnKeyClick(event) {
        if (appHelper.isDefined(event)) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.pauseAudio();
        }
    }

    render() {
        return (
                appHelper.isDefined(this.state.audio.locale[this.state.lang]) && appHelper.isDefined(this.state.audio.locale[this.state.lang].src)
                    ?
                    <div className="audio-container">
                        {
                            appHelper.isDefined(this.state.browser) && (this.state.browser !== "Internet Explorer")
                                ?
                                <div className="circular-audio-control-container">
                                    <CircularProgressbarWithChildren value={this.state.percentagePlayed}>
                                        {
                                            !this.state.audioIsPlaying
                                                ?

                                                <div className={`audio-control play-btn`} onClick={this.playAudio}
                                                     onKeyDown={this.playAudioOnKeyClick} role="link" tabIndex="0"
                                                     aria-controls="playAudio"/>
                                                :
                                                null
                                        }

                                        {
                                            this.state.audioIsPlaying
                                                ?
                                                <div className={`audio-control pause-btn`} onClick={this.pauseAudio}
                                                     onKeyDown={this.pauseAudioOnKeyClick} role="link" tabIndex="0"
                                                     aria-controls="pauseAudio"/>
                                                :
                                                null
                                        }
                                    </CircularProgressbarWithChildren>
                                </div>

                                :

                                <div>
                                    {
                                        !this.state.audioIsPlaying
                                            ?
                                            <div className={`audio-control play-btn`} onClick={this.playAudio}
                                                 onKeyDown={this.playAudioOnKeyClick} role="link" tabIndex="0"
                                                 aria-controls="playAudio"/>
                                            :
                                            null
                                    }

                                    {
                                        this.state.audioIsPlaying
                                            ?
                                            <div className={`audio-control pause-btn`} onClick={this.pauseAudio}
                                                 onKeyDown={this.pauseAudioOnKeyClick} role="link" tabIndex="0"
                                                 aria-controls="pauseAudio"/>
                                            :
                                            null
                                    }
                                </div>
                        }

                        {this.state.showLabels
                            ?<div className="flex-item">
                                {!this.state.audioIsPlaying
                                    ?
                                    <span>{this.state.play_label}</span>
                                    :
                                    <span>{this.state.pause_label}</span>
                                }

                            </div>
                            :
                            null
                        }

                        {this.state.showAnimation
                            ?
                            <div className="flex-item">
                                {this.state.audioIsPlaying
                                    ?

                                    <div className="audio-bars">
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    </div>

                                    :

                                    <div className="static-audio-bars">
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    <div className="bar"/>
                                    </div>
                                }
                            </div>
                            :
                            null
                        }
                        <audio ref={this.audioRef} src={this.getAssetPath(this.state.audio.locale[this.state.lang].src)} preload="auto"/>
                    </div>
                :
                    null

        );
    }
}

SimpleAudioController.propTypes = {
    audio: PropTypes.object.isRequired,
    audioRef: PropTypes.string.isRequired,
    autoPlay: PropTypes.bool.isRequired,
    themeType: PropTypes.string,
    showLabels: PropTypes.bool,
    showAnimation: PropTypes.bool,
    lang: PropTypes.string.isRequired,
    currentAudioId: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

SimpleAudioController.contextTypes = {
    router: PropTypes.object
};


function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        currentAudioId: state.currentAudioId
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userDataActions, trackingDataActions, appDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SimpleAudioController);



/** WEBPACK FOOTER **
 ** ./src/components/objects/audio/SimpleAudioController.js
 **/